module.exports = __webpack_public_path__ + "static/media/soja1.d3625bca.jpg";